import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dropdown",
    "dropdownButton",
    "searchInput",
    "queryList",
    "queryOption",
    "selectedContainer"
  ]

  connect() {
    // Close dropdown when clicking outside
    this.boundCloseDropdown = this.closeDropdownOnClickOutside.bind(this)
    document.addEventListener('click', this.boundCloseDropdown)
  }

  disconnect() {
    document.removeEventListener('click', this.boundCloseDropdown)
  }

  toggleDropdown(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle('hidden')

    // Focus search input when opening
    if (!this.dropdownTarget.classList.contains('hidden')) {
      setTimeout(() => this.searchInputTarget.focus(), 100)
    }
  }

  closeDropdownOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add('hidden')
    }
  }

  filterQueries(event) {
    const searchTerm = event.target.value.toLowerCase()

    this.queryOptionTargets.forEach(option => {
      const queryText = option.dataset.queryText
      if (queryText.includes(searchTerm)) {
        option.classList.remove('hidden')
      } else {
        option.classList.add('hidden')
      }
    })
  }

  updateSelection() {
    // Update button text based on selection count
    const checkedCount = this.getCheckedCheckboxes().length
    const buttonText = this.dropdownButtonTarget.querySelector('span')

    if (checkedCount === 0) {
      buttonText.textContent = 'All queries'
    } else if (checkedCount === 1) {
      buttonText.textContent = '1 query selected'
    } else {
      buttonText.textContent = `${checkedCount} queries selected`
    }
  }

  clearAll() {
    this.queryOptionTargets.forEach(option => {
      const checkbox = option.querySelector('input[type="checkbox"]')
      if (checkbox) {
        checkbox.checked = false
      }
    })
    this.updateSelection()
  }

  removeQuery(event) {
    const queryId = event.currentTarget.dataset.queryId

    // Uncheck the corresponding checkbox in the dropdown
    this.queryOptionTargets.forEach(option => {
      const checkbox = option.querySelector('input[type="checkbox"]')
      if (checkbox && checkbox.value === queryId) {
        checkbox.checked = false
      }
    })

    // Submit the form to apply changes immediately
    this.applyFilter()
  }

  applyFilter() {
    // Close dropdown
    this.dropdownTarget.classList.add('hidden')

    // Submit the form
    const form = this.element.closest('form')
    if (form) {
      form.submit()
    }
  }

  getCheckedCheckboxes() {
    return this.queryOptionTargets
      .map(option => option.querySelector('input[type="checkbox"]'))
      .filter(checkbox => checkbox && checkbox.checked)
  }
}
